import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setAuthToken = createAction(actionType.SET_AUTH_TOKEN);
const resetAuthToken = createAction(actionType.RESET_AUTH_TOKEN);
export { setAuthToken, resetAuthToken };
